import { Provider } from 'react-redux'
import { BrowserRouter, Route } from 'react-router-dom'
import { ThemeProvider } from '@mui/material'
import theme from '../../theme'
import Routes from '../../routes/index'
import configureStore from '../../appRedux/store'
import { StyledEngineProvider } from '@mui/material/styles'
import './App.css'
import { getGAEnvironment, pushToDataLayer } from '../../utils/gaEnvironment'

export const store = configureStore()

const App = () => {
  pushToDataLayer({ event: "gtm.js", env: getGAEnvironment() })
  return (
    <ThemeProvider theme={theme}>
      <StyledEngineProvider injectFirst>
        <Provider store={store}>
          <BrowserRouter>
            <Route path="/" component={Routes} />
          </BrowserRouter>
        </Provider>
      </StyledEngineProvider>
    </ThemeProvider>
  )
}

export default App
